var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("loading", {
    attrs: {
      active: _vm.sync,
      "is-full-page": _vm.fullPage,
      color: "#23C426",
      blur: "5px",
      height: 92,
      width: 92,
      opacity: 0.5,
      "z-index": 999,
      loader: "bars"
    },
    on: {
      "update:active": function($event) {
        _vm.sync = $event
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }